// extracted by mini-css-extract-plugin
export default {"button":"styles_button__rS+QR","title":"styles_title__djs8d"};